import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { StorageLabel } from "../../../../../mp-utils/generic-utils"
import storage from "../../../../../mp-core/helpers/storage"
import { getStudyPlansTransition } from "../../transitionalStates/getStudyPlansTransition"
import {
  Context,
  LoadableSchema,
  StudyPlanTargets,
  Transitions
} from "../../types"
import { getStudyPlanStorageKey } from "../../helpers"
import {
  getReviewPlanRedirect,
  setRedirectUrl
} from "../../actions/setRedirectUrl"

export const landingView: StateNodeConfig<
  Context,
  LoadableSchema,
  Transitions,
  BaseActionObject
> = {
  id: "landing_view",
  entry: [
    assign((ctx, evt, meta) => {
      if (ctx.previousParentState !== "landing_view") {
        return setRedirectUrl(ctx, evt, meta, StudyPlanTargets.Landing)
      }
    }),
    assign<Context>((ctx, _evt) => ({
      showLearnMore: !Boolean(
        storage.get(
          getStudyPlanStorageKey(StorageLabel.SP_LANDING_HELP, ctx.user.id)
        )
      ),
      currentTarget: StudyPlanTargets.Landing,
      previousParentState: "landing_view"
    }))
  ],
  initial: "loading",
  states: {
    loading: { ...getStudyPlansTransition },
    idle: {
      on: {
        MANAGE: {
          target: "#StudyPlan.study_plans_overview",
          actions: assign((_ctx, evt) => ({
            subject: evt.subject
          }))
        },
        FETCH_PLAN_BY_REF_SCOPE: {
          target: "#StudyPlan.get_current_plan",
          actions: assign((ctx, evt) => ({
            subject: evt.subject,
            currentTarget: StudyPlanTargets.ReviewPlan,
            ...getReviewPlanRedirect(ctx, evt.subject)
          }))
        },
        REPORTS: {
          // actions: "reportsPage" or target: "reports"
        },
        DISMISS_LEARN_MORE: {
          actions: [
            assign<Context>({ showLearnMore: false }),
            "rememberDismiss"
          ]
        }
      }
    }
  }
}
